import api from './api';

export type EmailOutboxStatus = 'PENDING' | 'PROCESSING' | 'RETRY' | 'SENT' | 'EXHAUSTED' | 'CANCELLED';

export type EmailOutboxItem = {
  id: string;
  recipient: string;
  subject: string;
  status: EmailOutboxStatus;
  attempts: number;
  nextAttemptAt: string;
  createdAt: string;
  updatedAt: string;
  sentAt?: string | null;
  lastError?: string | null;
  profile?: string | null;
};

export type EmailOutboxPage = {
  items: EmailOutboxItem[];
  total: number;
  page: number;
  size: number;
  totals: Record<EmailOutboxStatus | 'TOTAL', number>;
};

export type EmailOutboxFilters = {
  status: EmailOutboxStatus | '';
  search: string;
  createdFrom: string;
  createdTo: string;
};

const list = async (filters: EmailOutboxFilters, page: number, size: number): Promise<EmailOutboxPage> => {
  const { data } = await api.get<EmailOutboxPage>('/admin/email-outbox', {
    params: {
      status: filters.status || undefined,
      search: filters.search.trim() || undefined,
      createdFrom: filters.createdFrom || undefined,
      createdTo: filters.createdTo || undefined,
      page,
      size,
    },
  });
  return data;
};

const retry = async (id: string): Promise<void> => {
  await api.post(`/admin/email-outbox/${id}/retry`);
};

const cancel = async (id: string): Promise<void> => {
  await api.post(`/admin/email-outbox/${id}/cancel`);
};

export default { list, retry, cancel };
